import {
	advancedRoadmapsReduxStoreStateResource,
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsPlanReportPageInitialChecksResource,
	advancedRoadmapsLastVisitedProgramBoardIdResource,
} from '@atlassian/jira-router-resources-advanced-roadmaps-plan/src/services/index.tsx';
import { advancedRoadmapsSummaryDataResource } from '@atlassian/jira-router-resources-advanced-roadmaps-summary/src/services/summary-data/index.tsx';
import { useResourceInvalidate } from './utils.tsx';

/**
 * Cleanups the cache when the resource key change or unmount.
 * This way of invalidation is not available yet on the react-resource-router
 */
const PlanResourcesInvalidate = () => {
	useResourceInvalidate(advancedRoadmapsReduxStoreStateResource);
	useResourceInvalidate(advancedRoadmapsPlanPageInitialChecksResource);
	useResourceInvalidate(advancedRoadmapsPlanReportPageInitialChecksResource);
	useResourceInvalidate(advancedRoadmapsSummaryDataResource);
	useResourceInvalidate(advancedRoadmapsLastVisitedProgramBoardIdResource);
	return null;
};

export default PlanResourcesInvalidate;
